import { createFileRoute } from "@tanstack/react-router";
import { assertPagePermission } from "@/features/auth/lib/assert-page-permission";
import { pageStateQueryOptions, PageAccessError } from "@/lib/queries";
import { DashboardPage } from "@/features/dashboard/components/page/DashboardPage/DashboardPage";
import { PageError, PageAccessErrorComponent } from "@/features/auth/components/PageError";
import { usePageState } from "@/hooks/usePageState";
import { exploreRouteValidateSearch } from "@/features/dashboard/lib/explore-search-route";

function DashboardRoute() {
  const { isLoading, error } = usePageState("dashboard");
  if (isLoading) return null;
  if (error) return <PageError is403={error instanceof PageAccessError} />;
  return <DashboardPage />;
}

export const Route = createFileRoute("/_authenticated/dashboard")({
  beforeLoad: () => assertPagePermission("dashboard"),
  validateSearch: exploreRouteValidateSearch,
  loader: ({ context }) =>
    context.queryClient
      .ensureQueryData(pageStateQueryOptions("dashboard"))
      .catch((err: unknown) => {
        if (err instanceof PageAccessError) return null;
        throw err;
      }),
  component: DashboardRoute,
  errorComponent: PageAccessErrorComponent,
});
